export default "__VITE_ASSET__DMObzQS4__"